import React from 'react';
import classNames from 'classnames';
import { object, string, array } from 'prop-types';
import pathfinder from '@fiverr-private/pathfinder';
import { Button } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/i18n-react';
import Image from '../../../logged_out_homepage/shared/Image';
import SafeComponent from '../../../logged_out_homepage/shared/SafeComponent';
import { BQ_CLICKED_HOMEPAGE_LO_BUSINESS_SERVICES } from '../../../logged_out_homepage/utils/biEvents/events/bigQueryEvents';
import { MP_FIB_CLICK } from '../../../logged_out_homepage/utils/biEvents/events/mixPanelEvents';
import { LOHP_ROW, LOHP_INNER_ROW, MAX_WIDTH_CONTAINER } from '../../../logged_out_homepage/utils/constants';
import { sendBigQueryEvent, sendMixPanelEvent } from '../../../logged_out_homepage/utils/biEvents';
import { List } from './List';
import { defaultImgSrc, defaultCopyData, defaultPictureData } from './config';

import { Logo } from './Logo';

import './style.scss';

export const reportBi = () => {
    sendBigQueryEvent({ eventName: BQ_CLICKED_HOMEPAGE_LO_BUSINESS_SERVICES });
    sendMixPanelEvent({ eventName: MP_FIB_CLICK });
};

const getBusinessSolutionsPageUrl = () =>
    pathfinder('fiverr_business_solutions_page', {}, { query: { source: 'LOHP_business_banner' } });

const FiverrBusiness = (props) => {
    const { copyData = defaultCopyData, pictureData = defaultPictureData, imgSrc = defaultImgSrc } = props;

    return (
        <div className={classNames('fib-banner-wrapper', LOHP_ROW)}>
            <div className={classNames('fib-banner', LOHP_INNER_ROW, MAX_WIDTH_CONTAINER)}>
                <div className="grid-15 fib-banner-grid">
                    <div className="col-15-xs col-7-md business-text">
                        <div className="fib-banner-logo">
                            <i className="fib-banner-logo__logo">
                                <Logo />
                            </i>
                        </div>
                        <h2 className="font-domaine fib-banner-title">
                            <I18n k={copyData.title} />
                        </h2>
                        <List className="fib-banner-list" items={copyData.list} />
                        <div className="fib-banner-learn-more">
                            <Button
                                className="fib-banner-learn-more__button"
                                color="white"
                                textColor="dark-grey"
                                href={getBusinessSolutionsPageUrl()}
                                target="_blank"
                                onClick={reportBi}
                            >
                                <I18n k={copyData.button} />
                            </Button>
                        </div>
                    </div>
                    <div className="col-15-xs col-8-md business-image">
                        <picture>
                            {pictureData.map((image, index) => (
                                <source key={index} media={image.media} srcSet={image.srcSet} />
                            ))}
                            <Image src={imgSrc} loading="lazy" alt={copyData.alt} />
                        </picture>
                    </div>
                </div>
            </div>
        </div>
    );
};

FiverrBusiness.propTypes = {
    copyData: object,
    pictureData: array,
    imgSrc: string,
};

export default SafeComponent(FiverrBusiness);
